///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case = abcsetup.set_case || {};
abcsetup.set_case.users = abcsetup.set_case.users || {};
abcsetup.set_case.users.common = abcsetup.set_case.users.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case.users.common = {
    init: function() {
        $('#app_models_s_e_t_user__email').on('change', function() {
            abcsetup.set_case.users.common._checkExistingNonUsers($(this).val());
        });
    },

    /**
     *  Check SETUser records if email already exists
     *
     * @param {*} field
     */
    _checkExistingNonUsers: function(email) {
        abcsetup.blockUI(true);

        axios.post('/api/set_users/checkExistingNonUsers', { email: email }).then(response => {
            if (response.data && response.data.duplicate == true) {
                abcsetup.alerts.show('Existing SET Non-User', 'This e-mail address exists as a SET Non-User.');
            }
        });

        abcsetup.unblockUI();
    },
}